import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Avatar, Badge, Box, Button, Form, IconButton, Stack, Text, TextInput } from 'shell/components';

const TabletEditProfile = ({
    loading,
    form,
    isDirty,
    errors,
    onChange,
    onSubmit,
    onCancel,
    onClickEditProfileImage,
}) => {
    const { t } = useTranslation();

    return (
        <CustomStack spacing={4}>
            <Text component={'h1'} size={'small'} variant={'h6'} weight={'semibold'}>
                {t('account-settings.profile.title', 'Edit Profile')}
            </Text>
            <Box>
                <Badge
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                        <CustomIconButton
                            aria-label={'change avatar'}
                            kind={'edit'}
                            size={'small'}
                            variant={'circle'}
                            onClick={onClickEditProfileImage}
                        />
                    }
                    overlap={'circular'}
                >
                    <Avatar size={'x-large'} user={form} />
                </Badge>
            </Box>
            <CustomForm onSubmit={onSubmit}>
                <TextInput
                    error={Boolean(errors.first_name)}
                    helperText={errors.first_name}
                    label={t('account-settings.profile.first-name', 'First Name')}
                    required
                    value={form.first_name}
                    onChange={(e) => onChange('first_name', e.target.value)}
                />
                <TextInput
                    error={Boolean(errors.last_name)}
                    helperText={errors.last_name}
                    label={t('account-settings.profile.last-name', 'Last Name')}
                    required
                    value={form.last_name}
                    onChange={(e) => onChange('last_name', e.target.value)}
                />
                <TextInput
                    label={t('account-settings.profile.preferred-name', 'Preferred Name')}
                    value={form.display_name}
                    onChange={(e) => onChange('display_name', e.target.value)}
                />
                <TextInput
                    disabled={true}
                    error={Boolean(errors.email)}
                    helperText={errors.email}
                    label={t('account-settings.profile.email', 'Email')}
                    required
                    value={form.email}
                    onChange={(e) => onChange('email', e.target.value)}
                />
                <ButtonStack direction={'row-reverse'} spacing={2}>
                    <Button disabled={!isDirty} loading={loading} type={'submit'}>
                        {t('controls.save', 'Save')}
                    </Button>
                    {isDirty && (
                        <Button disabled={loading} variant={'secondary'} onClick={onCancel}>
                            {t('controls.cancel', 'Cancel')}
                        </Button>
                    )}
                </ButtonStack>
            </CustomForm>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(5),
        maxWidth: theme.spacing(180),
        height: 'calc(100vh - 64px - 20px)',
    };
});

const CustomIconButton = styled(IconButton)(({ theme }) => {
    return {
        border: `3px solid ${theme.palette.ensightful.shades[0]}`,
    };
});

const CustomForm = styled(Form)(({ theme }) => {
    return {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridGap: theme.spacing(4),
    };
});

const ButtonStack = styled(Stack)(() => {
    return {
        gridColumn: '1 / 3',
        marginLeft: 'auto',
    };
});

export default TabletEditProfile;
